import React, { Component } from 'react';
import { soundManager } from 'soundmanager2';

class PlayPause extends Component {

  constructor(){
    super();
    this.state = {
      playing: false
    };
  }

  componentDidMount() {
    soundManager.setup({
      debugMode: false,
      onready: function(){
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    // check to see if the stream url is different
    if(this.props.stream_url !== nextProps.stream_url){

      // if we have a stream destroy it
      if(this.stream){
        this.stream.destruct();
      }

      // create the new stream 
      this.createSound(nextProps.stream_url);
    }
  }

  createSound(stream_url){
    this.stream = soundManager.createSound({
      autoLoad: true,
      autoPlay: this.state.playing,
      volume: 100,
      stream: true,
      id: 'stream',
      url: stream_url,
    });
  }

  playPause(){
      if(!this.state.playing){
        this.createSound(this.props.stream_url);
        this.stream.play();
        this.setState({ playing: true });
      }else{
        this.stream.destruct();
        this.setState({ playing: false });
      }
  }

  render() {
    return (
      <div className="PlayPause">
        <button onClick={ this.playPause.bind(this) } >
            <span className="fa-stack fa-lg"> 
              <i className="fa fa-circle-o fa-stack-2x"></i> 
              <i className={ !this.state.playing ? "fa fa-play fa-stack-1x" : "fa fa-pause fa-stack-1x" }></i> 
            </span>
        </button>
      </div>
    );
  }
}

export default PlayPause;




// WEBPACK FOOTER //
// ./src/PlayPause.js